import React,{Suspense} from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import ArticleBlock from '../../adapters/helpers/ArticleBlock';
const BiographyContent = dynamic(() => import('../BiographyContent/BiographyContent'));
import Loader from '../../adapters/helpers/Loader';
import LazyLoad from 'react-lazy-load';

export default function ArticleBody(props) {
    const extraAttributes = props.extraAttributes || {};
    const article = extraAttributes.entity;

    const articleBlock = new ArticleBlock({document: props.document, article });

    const children = articleBlock.renderChildBlocks({ extraAttributes }, props.onClickCallback, props.customEvent);
    const biographyContent = articleBlock?.article?.biographyContent?.fields || null;
    const biographyModalArticleList = articleBlock?.article?.articleListsForBiographyModal || null

    return (
        <div className='ob-article-body'>
            <LazyLoad offset={100}>
                <>
            <Suspense fallback={<Loader />}>
            {children}
            </Suspense>
            <React.Fragment>
            <Suspense fallback={<Loader />}>
                {biographyContent && <BiographyContent biographyContent={biographyContent} biographyModalArticleList={biographyModalArticleList} />}
            </Suspense>
            </React.Fragment>
            </>
            </LazyLoad>
        </div>
    );
}

ArticleBody.propTypes = {
    className: PropTypes.string,
    extraAttributes: PropTypes.object,
    document: PropTypes.object,
    onClickCallback:  PropTypes.func,
    customEvent: PropTypes.object
};
